import component from "./ProfileAttentionsByType.vue"

import wrapVueComponent from "@/utils/wrapVueComponent"
const componentName = "StudentProfileAttentionsByType"

export default wrapVueComponent(componentName, component)
